/**
 * Detail beside its list (admin-design-r1 question 5). Open while `id` is set; the id lives in the URL through
 * useParam (`?open=box:lowtide`), so a phone push links straight to it and Back closes it. A side sheet on a desk, a
 * full screen with Back on a phone. Radix Dialog underneath, for focus, Escape and the screen-reader name.
 */
import * as Dialog from '@radix-ui/react-dialog'
import type { ReactNode } from 'react'
import { IconButton } from '../primitives/Button'
import { usePortal } from '../portal'
import s from './Drawer.module.css'

export function Drawer({
  id,
  onClose,
  title,
  children,
}: {
  id: string | null
  onClose: () => void
  title: string | ((id: string) => string)
  children: (id: string) => ReactNode
}) {
  const portal = usePortal()
  return (
    <Dialog.Root open={id !== null} onOpenChange={(open) => !open && onClose()}>
      <Dialog.Portal container={portal ?? undefined}>
        <Dialog.Overlay className={s.scrim} />
        <Dialog.Content className={s.drawer} aria-describedby={undefined}>
          {id !== null && (
            <>
              <div className={s.head}>
                <span className={s.back}>
                  <IconButton icon="back" label="Back" onClick={onClose} />
                </span>
                <Dialog.Title className={s.title}>{typeof title === 'function' ? title(id) : title}</Dialog.Title>
                <span className={s.close}>
                  <IconButton icon="close" label="Close" onClick={onClose} />
                </span>
              </div>
              <div className={s.body}>{children(id)}</div>
            </>
          )}
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  )
}
